module.exports = __webpack_public_path__ + "img/tpc-brochures-2.789439ae.webp";